import { Article } from '../articlesData';

export const articleHaandvaerkerkontraktAb18: Article = {
  id: 'haandvaerkerkontrakt-ab18-digital-aftale',
  slug: 'haandvaerkerkontrakt-ab18-digital-aftale',
  title: 'Håndværkerkontrakt og AB18: Sikr dine byggeopgaver med hurtig digital aftale',
  subtitle: 'Undgå tabte penge på ekstraarbejder og uenigheder med bygherrer. Sådan får håndværkere og entreprenører godkendt aftaler og tillæg på 30 sekunder med MitID.',
  metaTitle: 'Håndværkerkontrakt & AB18 Skabelon: MitID Signering | KvikSign',
  metaDescription: 'Skabelon og guide til håndværkerkontrakter, aftalesedler og AB18/AB Forbruger. Få kundens MitID-underskrift direkte på mobilen før arbejdet starter.',
  canonicalUrl: 'https://kviksign.com/da/articles/haandvaerkerkontrakt-ab18-digital-aftale',
  heroImage: 'https://firebasestorage.googleapis.com/v0/b/kviksign-db-europe/o/Website%2FPhotos%2FHandyman.webp?alt=media&token=8199e66b-f6f5-4fe9-b3ef-6201ee298da6',
  heroImageAlt: 'Håndværker og bygherre indgår aftale med digital signatur på byggepladsen',
  category: 'Håndværk & Byggeri',
  author: {
    name: 'KvikSign',
    role: 'eID & Sikkerhedsteam',
    avatar: '/icon.svg'
  },
  publishedAt: '2026-10-14',
  updatedAt: '2026-10-14',
  readingTime: '7 min læsetid',
  keywords: [
    'håndværkerkontrakt skabelon',
    'ab18 aftale digital signatur',
    'ab forbruger kontrakt skabelon',
    'aftaleseddel ekstraarbejde underskrift',
    'byggekontrakt mitid',
    'håndværker tilbud godkendelse online',
    'sikring mod ubetalte regninger håndværk',
    'digital aftale byggeplads'
  ],
  keyTakeaways: [
    'Mundtlige aftaler, SMS\'er og løse e-mails er den hyppigste årsag til, at håndværkere og entreprenører taber betaling for udført ekstraarbejde ved byggerier.',
    'AB 18 (for erhverv) og AB Forbruger (for private bygherrer) forudsætter klare skriftlige aftaler om tidsfrister, betalingsplaner og ændringsordrer.',
    'Med KvikSign kan mester eller montøren sende en aftaleseddel eller kontrakt direkte fra mobilen på byggepladsen, og kunden kan godkende med MitID eller touch-signatur med det samme.',
    'En digital signatur fjerner tvivl om, hvorvidt kunden har bestilt arbejdet, accepteret timeprisen eller godkendt en overskridelse af den oprindelige overslagspris.',
    'KvikSign integrerer let med fakturering og projektstyring, så alle godkendte aftaler automatisk ligger klar som bilag til slutregningen.'
  ],
  tableOfContents: [
    { id: 'hvorfor-mundtlige-aftaler-koster-dyrt-i-byggebranchen', title: 'Hvorfor mundtlige aftaler koster dyrt i byggebranchen' },
    { id: 'ab18-vs-ab-forbruger-hvad-skal-du-bruge', title: 'AB 18 vs. AB Forbruger: Hvad skal du vælge?' },
    { id: 'aftalesedler-paa-ekstraarbejde-mesters-bedste-ven', title: 'Aftalesedler på ekstraarbejde: Mesterens bedste ven' },
    { id: 'hvad-skal-en-god-haandvaerkerkontrakt-indeholde', title: 'Hvad skal en god håndværkerkontrakt indeholde?' },
    { id: 'sadan-bruger-du-kviksign-direkte-fra-byggepladsen', title: 'Sådan bruger du KvikSign direkte fra byggepladsen' },
    { id: 'download-gratis-haandvaerkerkontrakt-skabelon', title: 'Download gratis håndværkerkontrakt-skabelon' },
    { id: 'faq-haandvaerkerkontrakt', title: 'Ofte stillede spørgsmål' }
  ],
  sections: [
    {
      id: 'hvorfor-mundtlige-aftaler-koster-dyrt-i-byggebranchen',
      title: 'Hvorfor mundtlige aftaler koster dyrt i byggebranchen',
      paragraphs: [
        'Hvert år taber danske håndværksvirksomheder millioner af kroner på udført arbejde, som bygherren nægter at betale. I langt de fleste tilfælde skyldes problemet ikke dårligt udført håndværk, men mangelfuld dokumentation.',
        '"Det tager vi lige på regning" eller "Lav du bare det ekstra stykke rør" bliver sagt i farten på byggepladsen. Men når slutregningen kommer, husker bygherren aftalen anderledes eller påstår, at det var inkluderet i det faste tilbud.',
        'Ved en voldgiftssag eller civil retssag er det altid håndværkeren, der har bevisbyrden for, at der er indgået en aftale om ekstraarbejde og betaling.'
      ]
    },
    {
      id: 'ab18-vs-ab-forbruger-hvad-skal-du-bruge',
      title: 'AB 18 vs. AB Forbruger: Hvad skal du vælge?',
      paragraphs: [
        'Når du udarbejder kontrakter, afhænger vilkårene af, hvem din kunde er:',
        '• AB Forbruger: Skal anvendes ved opgaver for private forbrugere (f.eks. badeværelsesrenovering, nyt tag, solceller eller malerarbejde). Standarden beskytter forbrugeren mod uventede regninger og kræver skriftlig accept ved prisændringer.',
        '• AB 18: Anvendes ved B2B-byggerier og underentrepriser. Indeholder detaljerede bestemmelser om tidsplaner, dagbøder, sikkerhedsstillelse og mangelansvar.'
      ]
    },
    {
      id: 'aftalesedler-paa-ekstraarbejde-mesters-bedste-ven',
      title: 'Aftalesedler på ekstraarbejde: Mesterens bedste ven',
      paragraphs: [
        'Den mest kritiske fase i et byggeprojekt er, når der opstår uforudsete forhold (f.eks. råd i spærene eller skjulte kabler i væggen).',
        'I stedet for at fortsætte arbejdet på god tro bør montøren udfylde en kort aftaleseddel: Beskrivelse af ekstraarbejdet, estimeret merpris og eventuel tidsfristforlængelse.',
        'Med KvikSign kan denne aftaleseddel sendes til bygherrens telefon på få sekunder. Bygherren godkender med et MitID-klik, hvorefter håndværkeren kan fortsætte med ro i maven.'
      ]
    },
    {
      id: 'hvad-skal-en-god-haandvaerkerkontrakt-indeholde',
      title: 'Hvad skal en god håndværkerkontrakt indeholde?',
      paragraphs: [
        '• Opgavens præcise omfang (hvad er med, og hvad er ikke med).',
        '• Pris: Fast tilbud, overslag eller regningsarbejde med angivelse af timepris og materialetillæg.',
        '• Tidsplan med opstartsdato og forventet afleveringstidspunkt.',
        '• Betalingsbetingelser: Acontorater, forfaldsdato og renter ved forsinket betaling.',
        '• Henvisning til gældende standardbetingelser (AB 18 eller AB Forbruger).',
        '• Digital signatur fra begge parter.'
      ]
    },
    {
      id: 'sadan-bruger-du-kviksign-direkte-fra-byggepladsen',
      title: 'Sådan bruger du KvikSign direkte fra byggepladsen',
      paragraphs: [
        'KvikSign er mobiloptimeret og kræver ingen besværlig software. Du åbner blot KvikSign i browseren på din smartphone, vælger din håndværkerskabelon, taster bygherrens mobilnummer og trykker send.',
        'Kunden modtager straks en SMS med et direkte link, godkender med sit MitID, og begge parter modtager automatisk en forseglet PDF på mail.'
      ]
    },
    {
      id: 'download-gratis-haandvaerkerkontrakt-skabelon',
      title: 'Download gratis håndværkerkontrakt-skabelon',
      paragraphs: [
        'Vi har udarbejdet en overskuelig standardskabelon til håndværkeraftaler og aftalesedler for ekstraarbejder, der kan bruges af alle brancher (tømrere, elektrikere, murere, VVS\'ere mv.).'
      ]
    }
  ],
  faqs: [
    {
      question: 'Er en aftaleseddel underskrevet med MitID gyldig i Byggeriets Ankenævn?',
      answer: 'Ja, Ankenævnet for Byggeri tillægger skriftlige digitale aftaler med verificeret signatur afgørende bevisvægt i tvister.'
    },
    {
      question: 'Kan private kunder underskrive uden at have en computer?',
      answer: 'Ja, KvikSign fungerer problemfrit på alle smartphones. Kunden åbner blot SMS-linket og godkender i MitID-appen.'
    },
    {
      question: 'Hvad koster det at sende en aftaleseddel via KvikSign?',
      answer: 'Hos KvikSign betaler du en lav, fast pris uden abonnement eller skjulte gebyrer, så du trygt kan sikre selv små ekstraarbejder.'
    }
  ],
  sources: [
    { title: 'Dansk Byggeri / DI Byggeri - AB 18 standarder', url: 'https://www.danskindustri.dk' },
    { title: 'Forbrugerstyrelsen - Håndværkerregler og AB Forbruger', url: 'https://forbrug.dk' }
  ],
  disclaimer: 'Artiklen indeholder generel information om entrepriseret og byggeaftaler. Ved store entrepriser bør en erfaren byggerådgiver eller advokat konsulteres.'
};
